import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AddCustomAgeRangesService} from '../../../../shared/services/nso-data-portal/add-services/add-custom-age-ranges-service';
import {AgeGroupsData} from '../../../../shared/types/nso-data-portal/census-data';
// eslint-disable-next-line max-len
import {OrganizationInformationRestService} from '../../../../shared/services/nso-data-portal/rest-services/organization-information-rest.service';
// eslint-disable-next-line max-len
import {AdministrationInformationRestService} from '../../../../shared/services/nso-data-portal/rest-services/administration-information-rest.service';
import {SelectItem} from 'primeng/api';
import {GlobalMessagesService} from '../../../../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FormHelperService} from '../../../../shared/services/person/form-helper-service';
import {
  AgeOverlapValidation,
  AgeRequired,
  AgeStartEndValidation,
  AgeUniqueName
} from './add-custom-age-groups.validations';
import * as _ from 'lodash';

@Component({
  selector: 'wsd-add-custom-age-groups',
  templateUrl: './add-custom-age-groups.component.html',
  styleUrls: ['./add-custom-age-groups.component.css']
})
export class AddCustomAgeGroupsComponent implements OnInit {

  _organizationId: number;

  @Input()
  set organizationId(id: number) {
    if (id) {
      this._organizationId = id;
      this.loadData();
    }
  }

  @Output()
  onSave = new EventEmitter<AgeGroupsData[]>();

  display = false;

  globalGroupsItems: SelectItem[];

  groupsForm: UntypedFormGroup;

  constructor(private addService: AddCustomAgeRangesService,
              private message: GlobalMessagesService,
              private fb: UntypedFormBuilder,
              private formHelper: FormHelperService,
              private translate: TranslateService,
              private administrationService: AdministrationInformationRestService,
              private restService: OrganizationInformationRestService) {
    this.groupsForm = this.fb.group({
      groups: this.fb.array([])
    }, {
      validators: [
        AgeRequired,
        AgeUniqueName,
        AgeStartEndValidation,
        AgeOverlapValidation
      ]
    });

    this.administrationService.getAgeGroups().subscribe(
      (ageGroups: AgeGroupsData[]) =>
        this.globalGroupsItems = []
          .concat(
            ageGroups.map(group => {
              return {label: group.ageGroupName, value: group};
            })
          )
    );
  }

  ngOnInit() {
    this.addService.messageSent$.subscribe(
      () => {
        this.loadData();
        this.display = true;
      }
    );
  }

  loadData() {
    this.formHelper.clearFormArray(this.groups);
    this.restService.getCustomAgeGroups(this._organizationId).subscribe(
      res => res.forEach(g => this.addItem(g))
    );
  }

  save() {
    this.formHelper.validateAllFormFields(this.groupsForm);

    if (this.groupsForm.invalid) {
      return;
    }

    this.display = false;
    this.onSave.emit(this.groups.value);
  }

  createItem(group): UntypedFormGroup {
    const newGroup = this.fb.group({
      id: [null],
      global: [null],
      groupType: [null],
      defaultAgeGroup: [this.globalGroupsItems && this.globalGroupsItems[0].value],
      ageGroupName: '',
      endingAge: ['', Validators.min(0)],
      startingAge: ['', Validators.min(0)]
    });
    if (!_.isEmpty(group)) {
      newGroup.patchValue(group);
    }
    return newGroup;
  }

  addItem(group) {
    this.groups.push(this.createItem(group));
  }

  addSection() {
    this.addItem({});
  }

  removeSection(index) {
    this.groups.removeAt(index);
  }

  get groups() {
    return this.groupsForm.get('groups') as UntypedFormArray;
  }

  get customAgeGroupsWarning() {
    return _.map(_.filter(this.groupsForm.get('groups').value, group =>
      // @ts-ignore
      (group.ageGroupName === null || group.ageGroupName === '')), group => (group.defaultAgeGroup.ageGroupName));
  }
}
